import { render } from "./SharedProducts.vue?vue&type=template&id=0040702f&scoped=true"
import script from "./SharedProducts.vue?vue&type=script&lang=js"
export * from "./SharedProducts.vue?vue&type=script&lang=js"

import "./SharedProducts.vue?vue&type=style&index=0&id=0040702f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0040702f"]])

export default __exports__